export class EmployeeNoteModel {
    note_sequence: number
    employee_no: number
    note_text: string
    note_date: string
    active: string

    constructor(
        note_sequence: number,
        employee_no: number,
        note_text: string,
        note_date: string,
        active: string
    ) {
        this.note_sequence = note_sequence
        this.employee_no = employee_no
        this.note_text = note_text
        this.note_date = note_date
        this.active = active
    }
}